import { TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import AdherentBirthDate from "../../Comparison/Amellis/AdherenBirthdate";
import AdherentInfo from "../../Comparison/Amellis/AdherentInfo";
import AdherentTelecoms from "../../Comparison/Amellis/AdherentTelecoms";
import BankInformation from "../../Comparison/Amellis/BankInformation";
import BankInformationWithoutPayment from "../../Comparison/Amellis/BankInformationWithoutPayment";
import Loading from "../../Comparison/Amellis/Components/Loader";
import Default from "../../Comparison/Amellis/Default";
import EffectiveDate from "../../Comparison/Amellis/EffectiveDate";
import ElectronicSignature from "../../Comparison/Amellis/ESign";
import GenerateESignDocumentsWithoutPrice from "../../Comparison/Amellis/GenerateESignDocumentsWithRequiredNotice";
import Justification from "../../Comparison/Amellis/Justification";
import Needs from "../../Comparison/Amellis/Needs";
import ProductsPricePerBeneficiary from "../../Comparison/Amellis/ProductsPricePerBeneficiary";
import ProductsWithoutPrice from "../../Comparison/Amellis/ProductsWithoutPrice";
import RelatedPersons from "../../Comparison/Amellis/RelatedPersons";
import SelectBranch from "../../Comparison/Amellis/SelectBranch";
import SelectCollectivity from "../../Comparison/Amellis/SelectCollectivity";
import SocialSecurityNumber from "../../Comparison/Amellis/SocialSecurityNumber";
import SubscriptionDone from "../../Comparison/Amellis/SubscriptionDone";

const Templates = {
  Loading: <Loading />,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .PROFILE]: SelectCollectivity,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .SELECT_BRANCH]: SelectBranch,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .ADHERENT_BIRTHDATE]: AdherentBirthDate,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .NEEDS]: Needs,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .ADHERENT_INFO]: AdherentInfo,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .PRODUCTS]: ProductsWithoutPrice,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .PRODUCTS_PRICE_PER_BENEFICIARY]: ProductsPricePerBeneficiary,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .EFFECTIVE_DATE]: EffectiveDate,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .ADHERENT_TELECOMS]: AdherentTelecoms,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .ADHERENT_SOCIAL_SECURITY_NUMBER]: SocialSecurityNumber,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .RELATED_PERSONS]: RelatedPersons,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .ADHERENT_BANK_INFORMATION]: BankInformation,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .ADHERENT_BANK_INFORMATION_WITHOUT_PAYMENT]: BankInformationWithoutPayment,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .GENERATE_E_SIGN_DOCUMENTS]: GenerateESignDocumentsWithoutPrice,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .E_SIGN]: ElectronicSignature,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .JUSTIFICATIONS]: Justification,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]
    .SUBSCRIPTION_DONE]: SubscriptionDone,
  default: Default,
};
export default Templates;
